// Community Sorting Utilities
// Sorting algorithms for Hot, Top, and New posts

import { Post, SortOption } from '../types/community';

/**
 * Sort posts by "Hot" algorithm
 * Formula: score = (upvotes - downvotes) / (hoursSinceCreation + 2)^1.8
 * Higher score = more "hot"
 */
export const sortByHot = (posts: Post[]): Post[] => {
  const now = new Date();
  
  return [...posts].sort((a, b) => {
    const hoursA = (now.getTime() - a.createdAt.getTime()) / (1000 * 60 * 60);
    const hoursB = (now.getTime() - b.createdAt.getTime()) / (1000 * 60 * 60);
    
    const scoreA = (a.upvotes - a.downvotes) / Math.pow(hoursA + 2, 1.8);
    const scoreB = (b.upvotes - b.downvotes) / Math.pow(hoursB + 2, 1.8);
    
    return scoreB - scoreA; // Descending (higher score first)
  });
};

/**
 * Sort posts by "Top" algorithm
 * Formula: score = upvotes - downvotes
 * Sort descending
 */
export const sortByTop = (posts: Post[]): Post[] => {
  return [...posts].sort((a, b) => {
    const scoreA = a.upvotes - a.downvotes;
    const scoreB = b.upvotes - b.downvotes;
    return scoreB - scoreA; // Descending (higher score first)
  });
};

/**
 * Sort posts by "New" algorithm
 * Sort by createdAt descending (newest first)
 */
export const sortByNew = (posts: Post[]): Post[] => {
  return [...posts].sort((a, b) => {
    return b.createdAt.getTime() - a.createdAt.getTime(); // Descending (newest first)
  });
};

/**
 * Sort posts based on selected option
 */
export const sortPosts = (posts: Post[], sortOption: SortOption): Post[] => {
  switch (sortOption) {
    case 'hot':
      return sortByHot(posts);
    case 'top':
      return sortByTop(posts);
    case 'new':
      return sortByNew(posts);
    default:
      return sortByNew(posts);
  }
};

